import { to } from "await-to-js";
import http from "../http";
import urls from "../urls";

export default new (class {
  getProducts() {
    return to(http.get(`${urls.products.get}`));
  }
})();
